module.exports = __webpack_public_path__ + "media/Video 17.7c06c8f7.mp4";